<template>
  <TextInput
    v-validate.disable="{ regex: validationPattern }"
    :value="vanityId"
    name="vanityId"
    :error="errors.first('vanityId')"
    :class="{ 'is-invalid': errors.first('vanityId') }"
    :disabled="isTournamentFieldDisabled('vanity_id')"
    type="text"
    :placeholder="
      $t(
        '_web_tournament_additional_settings_vanity-url-placeholder',
        'Provide an ID for a vanity URL'
      )
    "
    :data-vv-as="
      $t(
        '_web_tournament_additional_settings_vanity-url-placeholder',
        'Provide an ID for a vanity URL'
      )
    "
    class="mb-5"
    @focus="isTouched = true"
    @blur="checkVanityId"
    @change="onChange"
  >
    <template #prepend>
      <TextBlock text="www.playhera.com/" class="h-mr-3" />
    </template>
  </TextInput>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TextInput from '@/components/atoms/form/HeraFormTextInput';
import TextBlock from '@/components/atoms/TextBlock';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentVanityIdSetting',
  inject: ['$validator'],
  components: {
    TextInput,
    TextBlock,
  },
  mixins: [translate('_web_tournament_additional_settings')],
  data() {
    return {
      isDirty: false,
      isTouched: false,
    };
  },
  computed: {
    ...mapGetters([
      'isTournamentFieldDisabled',
      'currentTournament',
      'currentTournamentInfo',
      'currentTournamentBackup',
    ]),
    vanityId: {
      get() {
        return this.$lodash.get(this.currentTournamentInfo, 'vanity_id', '');
      },
      set(newVal) {
        this.updateCurrentTournament({
          vanity_id: newVal,
          component: 'info',
        });
      },
    },
    validationPattern() {
      // old pattern that fails Japanese
      // /^[\w-_]+$/
      return /^[\w-\uff03\u30a0-\u30ff_]+$/;
    },
  },
  watch: {
    'currentTournamentInfo.title'(newVal, oldVal) {
      if (newVal && newVal !== oldVal && !this.isDirty) {
        this.getTournaments({
          page_size: 1,
          page_number: 0,
          name: newVal,
        })
          .then(response => {
            let idPart = (
              this.currentTournament.id || this.currentTournament.tempId
            )
              .split('-')
              .pop();

            let noJapaneseVal = newVal
              .replace(
                /[\uff03\uff06\u30a0-\u30ff\u3040-\u309f\u4E00-\u9FAF]/g,
                ''
              )
              .trim()
              .substring(0, 47 - idPart.length);

            this.vanityId =
              this.$lodash.kebabCase(
                `${noJapaneseVal}${response.total ? response.total + 1 : ''}`
              ) + `-${idPart}`;
            this.$nextTick(() => {
              this.checkVanityId();
            });
          })
          .catch(this.errorNotify);
      }
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
    ...mapActions([
      'checkVanityUrlForExisting',
      'getTournaments',
      'errorNotify',
    ]),
    onChange(e) {
      this.vanityId = e;
      if (this.isTouched) {
        this.isDirty = true;
      }
    },
    checkVanityId() {
      if (
        this.vanityId &&
        this.vanityId !==
          this.$lodash.get(this.currentTournamentBackup, 'info.vanity_id', '')
      ) {
        this.checkVanityUrlForExisting(this.vanityId)
          .then(() => {
            this.$validator.errors.add({
              field: 'vanityId',
              msg: this.$t(
                '_web_entity-edit-vanity-taken-error',
                '{field} is already taken',
                {
                  field: this.$$t('Tournament ID:', 'vanity-url'),
                }
              ),
              rule: 'custom',
            });
          })
          .catch(() => {
            this.errors.remove('vanityId');
          });
      }
    },
  },
};
</script>
